import CustomerOrderPreview from "./CustomerOrderPreview";

const PrintCustomerOrder: React.FC = () => {
  return (
    <div className="inner-container">
      <CustomerOrderPreview />
    </div>
  );
};

export default PrintCustomerOrder;
